[
  {
    "code": "GA-1",
    "name": "Estuaire"
  },
  {
    "code": "GA-2",
    "name": "Haut-Ogooué"
  },
  {
    "code": "GA-3",
    "name": "Moyen-Ogooué"
  },
  {
    "code": "GA-4",
    "name": "Ngounié"
  },
  {
    "code": "GA-5",
    "name": "Nyanga"
  },
  {
    "code": "GA-6",
    "name": "Ogooué-Ivindo"
  },
  {
    "code": "GA-7",
    "name": "Ogooué-Lolo"
  },
  {
    "code": "GA-8",
    "name": "Ogooué-Maritime"
  },
  {
    "code": "GA-9",
    "name": "Woleu-Ntem"
  }
]